<template>
    <v-main>
        <div class="content">
            <dashboard-core-app-bar/>
          <v-snackbar
              :timeout="-1"
              :value="dialog"
              elevation="5"
              centered
              top
              absolute
              shaped
              color="white"
          >
            <v-simple-table light>
              <template v-slot:default>
                <tbody>
                <tr>
                  <td class="font-weight-bold">Name</td>
                  <td class="pl-2">:</td>
                  <td class="px-5">{{$store.state.home.user.fullName}}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Branch</td>
                  <td class="pl-2">:</td>
                  <td class="px-5">{{$store.state.home.user.branch}}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider></v-divider>
            <div class="d-flex justify-center mt-5">
              <v-btn
                  color="primary"
                  class="mr-10"
                  small
                  @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                  color="primary"
                  dark
                  small
                  @click="emitLogout"
              >
                Logout
              </v-btn>
            </div>
          </v-snackbar>
            <router-view/>
        </div>
        <Footer/>
    </v-main>
</template>

<script>
    import DashboardCoreAppBar from "./AppBar";
    import Footer from "./Footer";
    import {EventBus} from '../../../../_helpers'
    export default {
        name: "DashboardCoreView",
      data(){
          return{
            dialog: false
          }
      },
        components: {Footer, DashboardCoreAppBar},

        methods: {
          openModal: function (){
            this.dialog = true
          },
          emitLogout: function() {
            EventBus.$emit('logout')
          }
        },
      created() {
        EventBus.$on('openModal', this.openModal)

      }
    }
</script>